import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { UsersState } from './types';
import { StateStatus } from '../../enums/StateStatus';

export const defaultUsersState: UsersState = {
  internalUsers: null,
  externalUsers: null,
  status: StateStatus.Initial,
  error: null,
  externalUserProfileDetails: null
};

export default function reducer(state: UsersState = defaultUsersState, action: Actions): UsersState {
  switch (action.type) {
    case ActionTypes.GET_INTERNAL_USERS:
    case ActionTypes.GET_EXTERNAL_USERS:
    case ActionTypes.UPDATE_INTERNAL_USER_ROLE:
    case ActionTypes.GET_EXTERNAL_USER_PROFILE_DETAILS:
    case ActionTypes.UPDATE_EXTERNAL_USER_PROFILE_DETAILS:
      return { ...state, status: StateStatus.Busy, error: null };
    case ActionTypes.UPDATE_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS:
    case ActionTypes.UPDATE_INTERNAL_USER_ROLE_SUCCESS:
      return { ...state, status: StateStatus.Loaded, error: null };
    case ActionTypes.GET_INTERNAL_USERS_SUCCESS:
    case ActionTypes.SET_INTERNAL_USERS:
      return { ...state, status: StateStatus.Loaded, internalUsers: action.payload };
    case ActionTypes.GET_EXTERNAL_USERS_SUCCESS:
      return { ...state, status: StateStatus.Loaded, externalUsers: action.payload };
    case ActionTypes.GET_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS:
      return { ...state, status: StateStatus.Loaded, externalUserProfileDetails: action.payload };
    case ActionTypes.GET_INTERNAL_USERS_ERROR:
    case ActionTypes.UPDATE_INTERNAL_USER_ROLE_ERROR:
    case ActionTypes.GET_EXTERNAL_USERS_ERROR:
    case ActionTypes.GET_EXTERNAL_USER_PROFILE_DETAILS_ERROR:
    case ActionTypes.UPDATE_EXTERNAL_USER_PROFILE_DETAILS_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
